<template>
  <div class="shoppe">
    <div class="query-form">
      <el-form label-position="right" label-width="100px">
        <el-row :gutter="20">
          <el-col :xs="24" :sm="24" :md="24" :lg="20" :xl="20">
            <el-row :gutter="10">
              <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6">
                <el-form-item label="国家名称">
                  <el-select v-model="queryForm.addressCountryId" filterable clearable>
                    <el-option v-for="item in countryList" :label="item.label" :value="item.value" :key="item.value"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
          </el-col>
          <el-col :xs="24" :sm="24" :md="24" :lg="4" :xl="4">
            <el-button @click="search" type="primary">查询</el-button>
            <el-button @click="reset">重置</el-button>
          </el-col>
        </el-row>
      </el-form>
    </div>

    <el-table :data="tableData">
      <el-table-column prop="name" label="国家名称"></el-table-column>
      <el-table-column prop="taxRate" label="税率"></el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button type="text" @click="editItem(scope.row)">编辑</el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-dialog append-to-body title="编辑税率" :visible.sync="dialogVisible" width="500px">
      <el-form ref="form" :model="form" label-width="150px">
        <el-form-item label="国家">{{ form.name }}</el-form-item>
        <el-form-item prop="taxRate" label="税率" :rules="[{ required: true, message: '请输入税率' }, { type: 'number', min: 0, message: '不能小于0'}]">
          <el-input-number v-model="form.taxRate" :precision="4" :controls="false"></el-input-number>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submit">确认创建</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  getTaxRateList,
  addTaxRate,
  updateTaxRate,
} from "./rate/api";
import {
  getCountryList,
} from '../../buyershop/cn/api';

export default {
  data() {
    return {
      countryList: [],
      queryForm: {
        addressCountryId: null,
      },
      tableData: [],
      dialogVisible: false,
      form: {
        name: null,
        taxRate: null,
        addressCountryId: null,
        taxId: null,
      },
    };
  },
  mounted() {
    getCountryList().then(res=>{
      this.countryList = res&&res.data&&(res.data.data || []).map(item=>{
        return {
          value:item.addressCountryId,
          label:item.name
        }
      })
    });
    this.getTableData();
  },
  methods: {
    search() {
      this.getTableData();
    },
    reset() {
      this.queryForm.addressCountryId = null;
      this.getTableData();
    },
    getTableData() {
      getTaxRateList(this.queryForm).then(res => {
        this.tableData = res.data.data;
      })
    },
    editItem(row) {
      this.form.name = row.name;
      this.form.taxRate = row.taxRate;
      this.form.addressCountryId = row.addressCountryId;
      this.form.taxId = row.taxId;
      this.dialogVisible = true;
    },
    submit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          if (!this.repeatSave) {
            this.repeatSave = true;
            let request = addTaxRate;
            if (this.form.taxId) {
              request = updateTaxRate;
            }
            request(this.form).then(res => {
              this.repeatSave = false;
              if (res.data.success) {
                this.$message.success('创建成功');
                this.dialogVisible = false;
                this.getTableData();
              } else {
                this.$message.error(res.data.message || '系统异常');
              }
            }).catch((err) => {
              this.repeatSave = false;
            })
          }
        } else {
          this.$message.error('请完善信息');
          return false;
        }
      });
    },
  },
};
</script>
<style lang="less" scoped>
.shoppe {
  padding: 20px;
}
.tr {
  margin-top: 10px;
  text-align: right;
}
.ml10 {
  margin-left: 10px;
}
</style>
